import { observer }                from "mobx-react";
import React                       from "react";
import shop                        from "shop/shop";
import { Link }                    from "react-router-dom";
import { Button, Container, Icon } from "semantic-ui-react";

@observer
export default class CurrentCustomerHeader extends React.Component {
  
  render() {
    const { session } = shop
    if ( !session.handId && !(session && (session.shopuser && session.shopuser.handid)) ) return null
    
    return <div className="CurrentCustomer ">
      <Container>
        <div className="relative flex flex-row items-center">
          <Link to={"/login/accounts/"} className={"hide-child show-monkey"} key="01">
            <div className="absolute pa1 white-70 child"><Icon name={"exchange"}/>{shop.session.customer.map_id || ""}
              <span className="f6 white-80"> {translate( "wechseln" )}</span>
            </div>
            <div className={"pa1 white-70 monkey"}>
              <Icon className={"white-70"} name="user"/>{shop.session.customer.map_id || translate( "Poweruser" )}
              {shop.session.customer.title && <span className="f6 white-70"> {shop.session.customer.title}, {shop.session.customer.pcode} {shop.session.customer.city}</span>}
            </div>
          </Link>
          
          <div className="ml-auto flex flex-row pa2">
            <Button primary id="customer-overview" as={Link} to={"/login/accounts/"} size={"tiny"}>{translate( "Kundenübersicht" )}</Button>
            <Button basic inverted as={Link} onClick={() => {
              shop.logout()
            }} to={"/login/"} size={"tiny"} icon={"power"}/>
          </div>
        
        </div>
      </Container>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/CurrentCustomerHeader.js